import classNames from 'classnames'
import { ElementType } from 'react'

import { Box } from '../Box'

import { TabProps } from './types'

const defaultElement = 'button'

export const Tab = <C extends ElementType = typeof defaultElement>({
  children,
  as,
  selected = false,
  ...props
}: TabProps<C>) => {
  const element: React.ElementType = as || defaultElement
  return (
    <Box
      as={element}
      className={classNames('tab', selected && 'tab--selected')}
      {...props}
    >
      {children}
    </Box>
  )
}
